module.exports = __webpack_public_path__ + "img/9.2b759703.png";